import { z } from "zod";

import { deliverableTypeSchema } from "./enums";

export const fieldSchema = z.object({
	fieldId: z.string(),
	packNetHeaderName: z.string(),
	customerHeaderName: z
		.string()
		.nullish()
		.transform((value) => value ?? ""),
	defaultValue: z.string().nullish(),
	isSecure: z.boolean().optional(),
});
export type Field = z.infer<typeof fieldSchema>;

export const computedFieldSchema = fieldSchema.extend({
	context: deliverableTypeSchema,
});
export type ComputedField = z.infer<typeof computedFieldSchema>;
